module.exports = __webpack_public_path__ + "static/media/quiz.a9639a8e.svg";